import { HistoryOutlined } from '@ant-design/icons'
import { Image, Skeleton } from 'antd'
import BackButton from 'components/BackButton'
import { ROOT_STORE } from 'constants/index'
import { addCommasToNumber } from 'helpers'
import RouteList from 'pages/Routes'
import { useNavigate } from 'react-router-dom'
import { useGetTokenWallet } from 'services/swr/token'
import { useGetMe } from 'services/swr/user'
import useTranslation from 'translations/useTranslation'
import { formatUnits } from 'utils'

const DepositPage = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const { data } = useGetTokenWallet()
	const { data: userData } = useGetMe()

	return (
		<div className='flex flex-col gap-5'>
			<BackButton title={t('walletManagement')} />

			{
				!userData
					? <Skeleton.Button active className='!w-full !h-[200px]' />
					: (
						<div
							className="mb-4 p-4 flex flex-col gap-4 border-solid border-[1px] rounded-2xl border-black"
							style={{ boxShadow: "#0a2790 12px 12px 0px" }}
						>
							<div className="flex items-center justify-between gap-4">
								<p className="">{t('totalWalletBalance')}</p>
								<HistoryOutlined
									className='text-xl'
									onClick={() => navigate(RouteList.walletHistory)}
								/>
							</div>
							<p className='text-2xl font-bold'>
								{addCommasToNumber(formatUnits(userData.token_alo.balance, +userData.token_alo.decimals))}
								<Image
									preview={false}
									src='/images/logo/main-logo.svg?v=1.4'
									alt='coin'
									width={24}
									className='object-cover !w-6 !h-6 rounded-[100%] ml-2 relative bottom-[2px]'
								/>
							</p>
						</div>
					)
			}

			{
				!data
					? <Skeleton.Node active className='!w-full !h-[70vh]' />
					: data.map(token => (
						<div
							key={token.id}
							className="flex items-center gap-3 p-3 cursor-pointer border border-solid border-primary rounded-xl"
							onClick={() => navigate(`/wallet/deposit/${token.id}`)}
						>
							<div className="flex-shrink-0 w-12 h-12 rounded-full relative">
								<Image preview={false} src={ROOT_STORE + token.image} alt={token.name} className='!object-cover' />
								<div className="absolute bottom-0 right-0 translate-x-1/4 translate-y-1/4 bg-white rounded-full p-[1px] border border-solid border-primary">
									<Image
										preview={false}
										src={ROOT_STORE + token.chain.image}
										alt={token.name}
										width={20}
										className='rounded-full object-cover'
									/>
								</div>
							</div>

							<div className="flex flex-col gap-1">
								<p className='font-bold text-base'>{token.symbol.toUpperCase()}</p>
								<p className='text-secondary text-xs'>{token.chain.name}</p>
							</div>

							<p className="flex-1 text-right font-bold text-lg">
								{addCommasToNumber(formatUnits(token.balance, +token.decimals), 6)}
							</p>
						</div>
					))
			}
		</div>
	)
}

export default DepositPage